import { ConfigFilterItem, ConfigItem } from 'Core/interfaces/filters'

import { Miscellaneous } from '.'

export enum StateHazCodeSearchFields {
	searchByCode = 'searchByCode',
	searchByName = 'searchByName'
}

export enum StateHazCodeFilterFields {
	stateProvinceName = 'stateProvinceName'
}

export declare namespace StateHazCode {
	interface Basic extends CodeEntity {
		stateProvince: Miscellaneous.StateProvince
	}

	namespace Form {
		interface Generic extends NameCode {
			stateProvinceId: number
		}
	}

	namespace Request {
		interface Generic extends NameCode {
			stateProvinceId: number
		}
	}

	namespace Search {
		interface Result {
			[StateHazCodeSearchFields.searchByCode]: Entity[]
			[StateHazCodeSearchFields.searchByName]: Entity[]
		}

		interface Config {
			[StateHazCodeSearchFields.searchByCode]: ConfigItem<StateHazCodeSearchFields>
			[StateHazCodeSearchFields.searchByName]: ConfigItem<StateHazCodeSearchFields>
		}
	}

	namespace Filters {
		interface Config {
			[StateHazCodeFilterFields.stateProvinceName]: ConfigFilterItem<string, string>
		}
	}
}
